const CONTABILIDAD_ROOT = 'contabilidad';

/*
 *Las rutas aqui contenidas son rutas absolutas, por lo que no necesitan el prefijo de la ruta base de la aplicación.
 */
export const AppRoutes = {
  CONTABILIDAD_ONDA: {
    ROOT: CONTABILIDAD_ROOT,
    GASTOS: `${CONTABILIDAD_ROOT}/gastos`,
    GASTOS_NEW: `${CONTABILIDAD_ROOT}/gastos/nuevo`,
    SEPA: `${CONTABILIDAD_ROOT}/sepa`,
    SEPA_NEW: `${CONTABILIDAD_ROOT}/sepa/nuevo`,
    FACTURAS_GASTOS_NO_PROCESABLES: `${CONTABILIDAD_ROOT}/gastos/facturas-no-procesables`,
    VENTAS: `${CONTABILIDAD_ROOT}/ventas`,
    VENTAS_NEW: `${CONTABILIDAD_ROOT}/ventas/nuevo`,
    FACTURAS_SEPA_NO_PROCESABLES: `${CONTABILIDAD_ROOT}/sepa/facturas-no-procesables`,
    CONTABILIDAD_MAESTROS: `${CONTABILIDAD_ROOT}/contabilidad-maestros`,
  },
};
